/* eslint-disable max-len */
// /* eslint-disable max-len */
// /* eslint-disable security/detect-object-injection */
// import React, { useState, memo, useEffect } from 'react'
// import ErrorMessage from '../ErrorMessage'

// export default memo(function FloatingInput(props) {
//     const { setsubmitSelected,
//         submitSelected,
//         value,
//         inputType,
//         id,
//         handleInput,
//         state,
//         classKey,
//         labelCalss,
//         errorImage,
//         normalImage,
//         isPassword,
//         errorState,
//         floatingImage,
//         reference,
//         optional,
//         placeholder,
//         disabled,
//         text,
//         typess,
//         types, idx } = props
//     const [type, settype] = useState('text');
//     useEffect(() => {
//         settype('password')
//     }, [submitSelected])
//     return (
//         <>
//             <input
//                 id={id}
//                 type={inputType ? inputType : isPassword ? type : 'text'}
//                 ref={reference}
//                 data-testid={id}
//                 value={value}
//                 onFocus={() => setsubmitSelected(false)}
//                 placeholder={placeholder || ''}
//                 onChange={(e) => {
//                     if (types === 'number') {
//                         e.target.value.replace('-', '')
//                         if (/^\d*$/.test(e.target.value) || e.target.value !== '-') {
//                             handleInput(e, types, idx)
//                         }
//                     } else {
//                         handleInput(e, types, idx)
//                     }
//                 }}
//                 disabled={disabled}
//                 className={classKey} />
//             <label htmlFor={id} class={labelCalss}>{text}</label>

//             {floatingImage && <button type="button" className={`cursor-pointer absolute ${optional === undefined && submitSelected && (value == '' || ((errorState[id] && errorState[id] !== ''))) ? 'top-[32%]' : 'top-[50%]'}  -translate-y-[50%] right-3.5`}>
//                 {/* {isPassword ? <>{type === 'text' ?
//                     <img loading="lazy" src="/assets/images/eye-open.svg" alt="password-show" className="password-show" onClick={() => settype('password')} />
//                     : <img loading="lazy" src={`/assets/images/${submitSelected && (value == '' || ((errorState[id] && errorState[id] !== ''))) ? 'eye-error.svg' : 'eye.svg'}`} alt="password-hide" className="password-show" onClick={() => settype('text')} />}</> : <img loading="lazy" src={`/assets/images/${submitSelected && (value == '' || ((errorState[id] && errorState[id] !== ''))) ? `${errorImage}` : `${normalImage}`}`} alt="password-show" className="password-show" />
//                 } */}

//             </button>}
//             {optional === undefined && submitSelected && (value == '' || ((errorState[id] && errorState[id] !== ''))) && <ErrorMessage error message={errorState[id] || 'This field is mandatory'} classKey='itext-f4 text-sm font-normal text-[#FC4523] mt-[8px] login-err' />}

//         </>
//     )
// })


/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useRef } from 'react'
import { exceptThisSymbols } from '../../config'
import ErrorMessage from '../ErrorMessage'
export default function Input(
    { type,
        state,
        id,
        handleInput,
        submitSelected,
        setsubmitSelected,
        className,
        text,
        maxLength,
        customError,
        optional,
        ref,
        labelCalss,
        value,
        disabled,
        minVal,
        placeholder, newType, idx }) {
    const inputRef = useRef(null);
    
    return (
        <>
            <input
                type={type || "text"}
                id={id}
                ref={inputRef}
                data-testid={id}
                autoComplete='off'
                maxLength={maxLength ? maxLength : ''}
                value={newType ? value : state[id]}
                pattern="[^\s]+"
                onKeyDown={e => {
                    if (e.keyCode === 13) e.preventDefault()
                    if (type === 'number') {
                        exceptThisSymbols.filter(s => s !== '.').includes(e.key) && e.preventDefault()
                    } else if (e.key === ' ' && state[id] === '') {
                        e.preventDefault()
                    }
                }}

                onWheel={(e) => e.target.blur()}
                onChange={(e) => {
                    if (type === 'number') {
                        // Only allow digits and decimal point
                        let value = e.target.value.replace(/[^0-9.]/g, '');
                        // Prevent multiple decimal points
                        const parts = value.split('.');
                        if (parts.length > 2) {
                            value = parts[0] + '.' + parts.slice(1).join('');
                        }

                        // Restrict to 4 decimal places
                        if (parts.length === 2 && parts[1].length > 4) {
                            return;
                        }

                        // Enforce maxLength limit
                        if (maxLength && value.length > maxLength) {
                            return;
                        }
                        
                        // For commission field, restrict to max 100 only if commission type is percentage
                        if (id === 'commission' && value !== '' && state.commission_type === 'commission_percentage') {
                            const numValue = parseFloat(value);
                            if (numValue > 100) {
                                return;
                            }
                        }
                        
                        e.target.value = value;
                        handleInput(e, newType, idx)
                    } else {
                        // Enforce maxLength limit for text inputs
                        if (maxLength && e.target.value.length > maxLength) {
                            return;
                        }
                        handleInput(e, newType, idx)
                    }
                }}
                onFocus={() => setsubmitSelected(false)}
                className={`${submitSelected && state[id] === '' && optional === undefined || (customError && submitSelected && state[id] !== '') ? ' border border-[#FDA29B] ' : ' border border-[#D0D5DD] '}${className} `}
                placeholder={''}
                min={minVal}
                disabled={disabled}
            />
            <label onClick={() => inputRef.current?.focus()} className={`${labelCalss} cursor-pointer`}>{placeholder}</label>

            {(submitSelected && state[id] === '' && optional === undefined) &&
                <ErrorMessage
                    message={text}
                    classKey="text-f1 font-normal text-[#F04438] add-error2 pt-1.5"
                    error
                />}
        </>

    )
}